import axios from 'axios'
import cookie from 'react-cookies'

export function Req(url, lang) {

  let token_cookie = cookie.load("HB_token");
  let token_sessionStorage = sessionStorage.getItem("HB_token");
  console.log("token take place ===>",token_cookie,token_sessionStorage)
  let token = `Bearer ${token_cookie ? token_cookie : JSON.parse(token_sessionStorage)}`
  console.log("token take place ===>",token)
  
  return new Promise((resolve, reject) => {
    axios.get(url,
      { headers: { "Content-Type": "application/json", Authorization: token, 'Accept-Language': lang ? lang : "ar" } }).then(res => {
        console.log('reqq res=> ',res.data)
        resolve(res);
      }).catch(err =>{
        console.log('reqq res=> ',err.response)
        reject(err)
      } );
  });
}